
<template id="recursive-menu">
  <component
    :is="menuComponent"
    v-if="!routerInfo.hidden"
    :router-info="routerInfo"
  >
    <template v-if="routerInfo.children&&routerInfo.children.length">
      <recursive-menu
        v-for="item in routerInfo.children"
        :key="item.name"
        :router-info="item"
      />
    </template>
  </component>
</template>

<script>
import MenuItem from './menuItem'
import AsyncSubmenu from './asyncSubmenu'
export default {
  name: 'recursive-menu',
  components:{
    MenuItem,
    AsyncSubmenu
  },
  props: {
    routerInfo: {
      type: Object,
      default: () => null,
    }
  },
  computed:{
    menuComponent:function (){
      if (this.routerInfo.children) {
        return AsyncSubmenu
      } else {
        return MenuItem
      }
    }
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/components/recursive.vue